<template>
  <div ref="headerSearchRef" :class="`${bem.e('header-wrapper')}`">
    <div :class="bem.e('header')">
      <slot name="header">
        <!-- 左边的插槽 -->
        <div :class="bem.e('header-left')">
          <slot name="headerLeft"> </slot>
        </div>
        <!-- 内容中间插槽 -->
        <div :class="bem.e('header-middle')">
          <slot name="headerMiddle"></slot>
        </div>
        <div :class="bem.e('header-right')">
          <slot name="headerRight"></slot>
          <!-- 切换table和list菜单 -->
          <a-radio-group
            v-if="props.menuSwitchOptions?.show"
            v-model:value="contentType"
            :class="`${bem.e('header-menu-radio-group')}`"
            @change="handleMenuSwitchChange"
          >
            <a-radio-button
              v-for="menuItem in menuSwitchRadioList"
              :key="menuItem.value"
              :class="`${bem.e('header-menu-icon')}`"
              :value="menuItem.value"
            >
              <ll-icon :icon-name="menuItem.icon" :size="18" />
            </a-radio-button>
          </a-radio-group>
        </div>
      </slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, inject, watch, onUnmounted } from 'vue'

import {
  menuSwitchRadioList,
  tableHeaderSearchEmits,
  ImenuSwitchType
} from '../config'
import { createNamespace } from '@ll-plus/utils'
import { tableHeaderSearchProps } from '../config'

import { LlIcon } from '@ll-plus/components'

import type { RadioChangeEvent } from 'ant-design-vue'

// 1.defineOptions
defineOptions({
  name: 'TableHeaderSearch'
})

// 2.props
const props = defineProps(tableHeaderSearchProps)

const headerSearchRef = ref() // headerSearch的ref
// 获取menuswitch
const contentType = inject('contentType')
let observer: MutationObserver // 监听dom内容发生变化

// 3.emits
const emits = defineEmits(tableHeaderSearchEmits)
// 4.const
const bem = createNamespace('table')

// 5.methods
// 切换菜单table
const handleMenuSwitchChange = (event: RadioChangeEvent) => {
  const target = event.target
  const value = target.value as ImenuSwitchType
  props.menuSwitchOptions.onChange && props.menuSwitchOptions.onChange(value)
  emits('change', value)
}
// 6.watch
watch(
  headerSearchRef,
  () => {
    if (headerSearchRef.value) {
      // 创建一个新的MutationObserver对象
      if (!observer) {
        observer = new MutationObserver(function (mutations) {
          mutations.forEach(function () {
            // 检查容器的高度变化
            const newHeight =
              headerSearchRef.value.getBoundingClientRect().height
            emits('changeHeaderSearch', newHeight)
          })
        })

        // 配置MutationObserver，监听子节点的变化
        const config = {
          childList: true, // 观察直接子节点
          subtree: true // 及其更低的后代节点
        }

        // 开始监听容器的变化
        observer?.observe(headerSearchRef.value, config)
      }
    }
  },
  {
    immediate: true,
    deep: true
  }
)

// 组件卸载停止监听
onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})
</script>
